export default __webpack_public_path__ + "static/media/SectionViewImg.dbda921e.jpg";